// extracted by mini-css-extract-plugin
export default {"title":"Articles_title__Tf-ws","seeMore":"Articles_seeMore__XeSRe"};